import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const ParameterRef = pipe(
	string,
	parse((s) =>
		s.startsWith(`parameter.`) || s === 'measurement.height' || s === 'measurement.pitch'
			? success(s)
			: failure(s, 'Invalid wholehouse parameter name should start with `parameter.`')
	)
);
